import { useQuery } from "@tanstack/react-query";
import { api } from "@/store/StoreContext";

export const useProducts = (collection) =>
  useQuery({
    queryKey: ["products", collection || "semua"],
    queryFn: async () => {
      const { data } = await api.get("/products", {
        params: collection && collection !== "semua" ? { collection } : {},
      });
      return data;
    },
  });

export const useProduct = (slug) =>
  useQuery({
    queryKey: ["product", slug],
    enabled: Boolean(slug),
    queryFn: async () => {
      const { data } = await api.get(`/products/${slug}`);
      return data;
    },
  });
